module.exports = __webpack_public_path__ + "static/9-7fdb34f39f5eece119dfd7d5a63f04b1.jpg";